<fgb-banner [pageTitle]="name$ | async" />

<fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-account-nav></fgb-account-nav>

<div class="container mt-lg-4 mt-3 pt-2">
  <div class="row m-lg-0">
    <div class="col-12 col-lg-6 ps-lg-0">
      <ng-container *ifScreenSize="screenType.Desktop">
        <div class="d-flex flex-column justify-content-between h-100">
          <div class="membercard mb-0 mb-lg-4">
            <h5 class="my-3 mt-lg-0 d-none d-lg-block font-size-18">{{ 'account.member.card.title' | translate }}</h5>
            <fgb-member-card showSeating="true" isAccount="true"></fgb-member-card>
          </div>

          <div class="refer-card d-flex flex-column align-items-center justify-content-center text-white mt-3">
            <div class="refer-title text-center">{{ 'account.member.refer.info' | translate }}</div>
            <a href="https://www.newyorkredbulls.com/referral-program">
              <button class="btn btn-refer">{{ 'account.member.refer.btn' | translate }}</button>
            </a>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-12 col-lg-6 pe-lg-0">
      <h5 class="mb-3 font-size-18">{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>
    </div>
    <div class="col-12">
      <div class="d-lg-none d-block">
        <div class="refer-card d-flex flex-column align-items-center justify-content-center text-white">
          <div class="refer-title text-center">{{ 'account.member.refer.info' | translate }}</div>
          <a href="https://www.newyorkredbulls.com/referral-program">
            <button class="btn btn-refer">{{ 'account.member.refer.btn' | translate }}</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
